<div class="st-page spnf-page">
  <div class="spnf-illustration">
    <i class="ri-map-pin-line"></i>
  </div>
  <h1 class="spnf-code">404</h1>
  <h2 class="spnf-title">{{ 'staffPageNotFoundTitle' | translate }}</h2>
  <p class="spnf-text">{{ 'staffPageNotFoundMessage' | translate }}</p>
  <button class="st-btn st-btn-primary" (click)="goToDefaultScreen()">
    <i class="ri-home-line"></i> {{ 'backToHome' | translate }}
  </button>
</div>
